import type {ReactElement} from 'react';
import React from 'react';
import {RemoveImageBackgroundNotificationTag} from '@Components/poster-editor/components/remove-image-background-notification-tag';
import {RemoveVideoBackgroundNotificationTag} from '@Components/poster-editor/components/remove-video-background-notification-tag';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromSelectedVideoSlide} from '@Hooks/poster-editor/useGetKeyFromSelectedVideoSlide';

export function SlideItemRemoveBgNotificationTag(): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const removeBgObject = useGetKeyFromSelectedVideoSlide('removeBackground');

  if (activeSlide?.isImageSlide()) {
    return <RemoveImageBackgroundNotificationTag hashedFilename={activeSlide.hashedFilename} imageSource={activeSlide.imageSource} />;
  }
  if (activeSlide?.isVideoSlide()) {
    return (
      <RemoveVideoBackgroundNotificationTag
        key={String(removeBgObject?.isBackgroundBeingRemoved)}
        videoHashedFilename={activeSlide.hashedFilename}
        startTime={activeSlide.getStartTimeForNonRemovedBgVideo()}
        endTime={activeSlide.getEndTimeForNonRemovedBgVideo()}
      />
    );
  }

  return null;
}
